import { axiosRequest } from "../../configs/axios.config";

export class EducationService {
  
  getUniversities(params, success, error) {
    return axiosRequest.get(`/public/universities`, {params: params})
    .then(({data}) => success(data))
    .catch(errorResp => error(errorResp))
  }
}
